import {type ClassValue, clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export const openInNewWindow = (url: string): void => {
  window.open(
    url,
    '_blank',
    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600',
  )
}

export function randomId(): string {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  )
}

export function spaceInCamelCase(str: string): string {
  if (!str) return ''
  return str
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace('C X', 'CX')
    .replace('B I', 'BI')
}

export function findKeyByValue<T>(
  obj: Record<string, T>,
  value: T,
): string | undefined {
  return Object.keys(obj).find(key => obj[key] === value)
}

export function getLabelPositionClass(
  labelPosition: 'top' | 'left' | 'right',
): string {
  switch (labelPosition) {
    case 'top':
      return 'flex-col-reverse'
    case 'left':
      return 'flex-row-reverse gap-2'
    case 'right':
      return 'flex-row gap-2'
    default:
      return ''
  }
}
